import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-right"
                theme="light"
                toastOptions={{
                    style: {
                        background: "#091524",
                        color: "#ffffff",
                        border: "1px solid rgba(255,255,255,0.1)",
                        borderRadius: "2px",
                    },
                }}
            />
        </div>
    );
}

export default App;
